import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'title',
    defaultMessage: 'Custom Primers: {value} Basic Form',
  },
  filesInstructions: {
    id: 'filesInstructions',
    defaultMessage: `Order multiple custom {value} oligos in plate format by selecting 
    either 96 or 384-wells formats. Simply download either the 96-well Excel template 
    or 384-well Excel template and enter your sequence and plate location information. 
    Save it as a .xls, .csv, or .txt and then upload it below. 
    After uploading you will be able to customize your order and add to cart.`,
  },
  japanFilesInstructions: {
    id: 'japanFilesInstructions',
    defaultMessage: `Currently, only 96 wells can be ordered from this web system.
    The minimum order quantity is 24 primers per plate.
    If you wish to order delivery in 384 wells, 
    please contact "Order Support: 03-6832-6980 Guidance 2".
    If you choose the 96-well format, you can order multiple custom DNA oligos in plate format.
    Simply download the 96-well Excel template and enter your 
    sequence and plate location information.
    Save the file in .xls or .csv or .txt format and upload it below.
    After the upload was completed,
    you will be able to customize your order and add it to your cart.`,
  },

  email: {
    id: 'email',
    defaultMessage: 'Email'
  },
  emailsList: {
    id: 'emailsList',
    defaultMessage: 'Email List'
  },
  emailAddress: {
    id: 'emailAddress',
    defaultMessage: 'Email Address'
  },
  emailModalTitle: {
    id: 'emailModalTitle',
    defaultMessage: 'Share Custom Oligos'
  },
  emailPlaceholder: {
    id: 'emailPlaceholder',
    defaultMessage: 'Enter a email'
  },
  add: {
    id: 'add',
    defaultMessage: 'Add'
  },
  shareOrder: {
    id: 'shareOrder',
    defaultMessage: 'Share Order'
  },
  nonEmptyValidatorMessage: {
    id: 'nonEmptyValidatorMessage',
    defaultMessage: 'This field can not be empty'
  },
  invalidEmail: {
    id: 'invalidEmail',
    defaultMessage: 'Please enter valid email address'
  },
  emailAlreadyMentioned: {
    id: 'emailAlreadyMentioned',
    defaultMessage: 'Email has been added already'
  },
  genericEmailErrorMessage: {
    id: 'genericEmailErrorMessage',
    defaultMessage: 'A problem occured while trying to share order details to all the recipients.'
  },
  emailApiSuccessMsg: {
    id: 'emailApiSuccessMsg',
    defaultMessage: 'Order details have been shared successfully to {successfulEmails}.'
  },
  emailApiFailureMsg: {
    id: 'emailApiFailureMsg',
    defaultMessage: 'We were not able to share the Order details to {errEmails}.'
  },
  maxEmailCount: {
    id: 'maxEmailCount',
    defaultMessage: `Maximum of {maxValue} Emails Ids can be added,
     if you wish to add a new one, please remove one from the already added mail ids`
  }
});

export default messages;
